import React from "react";
import { localize } from "redux-i18n";
import { Chart } from "@components";

type Props = $Exact<{
  charts: [],
}>;

export class SlaPerformanceChart extends React.Component<Props> {
  render() {
    return (
      <div className="department-details-report-table w-100">
        {this.props.charts.length < 1 ? (
          <div className={"center-aligned-text"}>
            <h3>{this.props.t("NO_DATA_PLEASE_APPLY_FILTERS")}</h3>
          </div>
        ) : (
          <Chart
            type="LineChart"
            title={this.props.t("SLA_PERFORMANCE")}
            values={[
              [
                "Period",
                this.props.t("SLA_PERFORMANCE"),
                this.props.t("SCHEDULED_CALLBACKS_SLA_PERCENTAGE"),
                this.props.t("NOTIFICATIONS_SLA_PERCENTAGE"),
              ],
              ...[
                ...this.props.charts.map(i => [
                  i.month,
                  parseFloat(i.asapCallbacksSlaPercentage),
                  parseFloat(i.scheduledCallbacksSlaPercentage),
                  parseFloat(i.notificationsSlaPercentage),
                ]),
              ],
            ]}
          />
        )}
      </div>
    );
  }
}

export default localize()(SlaPerformanceChart);
